import React from "react";
import Container from "../components/common/Container";
import SectionHeader from "../components/common/SectionHeader";
import { Target, Eye, HeartHandshake } from "lucide-react";

const About = () => {
  return (
    <>
      {/* Intro */}
      <section className="bg-slate-50 py-24">
        <Container>
          <center>
          <SectionHeader
            eyebrow="About Brightly"
            title="Building software that makes an impact"
            subtitle="Brightly LLC is a technology-driven software company focused on delivering scalable, secure, and innovative digital solutions for businesses worldwide."
          />
          </center>
        </Container>
      </section>

      {/* Mission / Vision / Values */}
      <section className="py-24 bg-white">
        <Container>
          <div className="grid gap-12 md:grid-cols-3">
            <div className="text-center">
              <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-100 text-blue-600">
                <Target size={26} />
              </div>
              <h3 className="mt-6 text-xl font-semibold text-slate-900">
                Our Mission
              </h3>
              <p className="mt-3 text-sm text-slate-600 leading-relaxed">
                To help businesses transform ideas into powerful digital products
                through thoughtful design and robust engineering.
              </p>
            </div>

            <div className="text-center">
              <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-100 text-blue-600">
                <Eye size={26} />
              </div>
              <h3 className="mt-6 text-xl font-semibold text-slate-900">
                Our Vision
              </h3>
              <p className="mt-3 text-sm text-slate-600 leading-relaxed">
                To become a trusted global software partner known for quality,
                innovation, and long-term value creation.
              </p>
            </div>

            <div className="text-center">
              <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-100 text-blue-600">
                <HeartHandshake size={26} />
              </div>
              <h3 className="mt-6 text-xl font-semibold text-slate-900">
                Our Values
              </h3>
              <p className="mt-3 text-sm text-slate-600 leading-relaxed">
                Integrity, collaboration, and a relentless focus on delivering
                meaningful outcomes for our clients.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* Story */}
      <section className="bg-slate-50 py-24">
        <Container size="sm">
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 text-center">
            Our Story
          </h2>
          <p className="mt-6 text-base text-slate-600 leading-relaxed text-center">
            Brightly LLC was founded with the belief that great software is built
            at the intersection of strategy, design, and engineering. We partner
            closely with startups and established organizations to deliver
            digital solutions that are not only technically sound but also
            aligned with real business needs.
          </p>
        </Container>
      </section>
    </>
  );
};

export default About;
